import { useQuery } from '@tanstack/react-query';
import { RegistriesAPI } from '@newo/api/gateway';

import { designerV2API } from '@/services/designer/designerV2Client';
import axios from '@/utils/api/axiosInstance';

const registriesAPI = new RegistriesAPI(axios);

interface UseRegistriesQueryOptions {
    enabled?: boolean;
    isProjectsV2Enabled?: boolean;
}

export const useRegistriesQuery = ({
    enabled = true,
    isProjectsV2Enabled = false
}: UseRegistriesQueryOptions = {}) => {
    return useQuery({
        queryKey: ['registries', isProjectsV2Enabled],
        queryFn: async () => {
            if (isProjectsV2Enabled) {
                return designerV2API.listRegistries();
            }

            return registriesAPI.getRegistries();
        },
        enabled
    });
};
